module.exports = __webpack_public_path__ + "static/media/hyllie.65b1c12b.png";